import { useQuery } from "@tanstack/react-query";
import { api, fmtDateTime } from "../../lib/api";
import { usePatient } from "../../hooks/useData";
import { PageHeader, Panel, SimBadge } from "./CareLayout";
import { PatientPicker, usePickedPatient } from "./PatientPicker";

const COLS = [
  ["right_arm_raise_deg", "Élév. bras D", "°"], ["left_arm_raise_deg", "Élév. bras G", "°"], ["reach_forward_cm", "Atteinte avant", " cm"],
  ["reach_left_cm", "Atteinte G", " cm"], ["reach_right_cm", "Atteinte D", " cm"], ["right_leg_lift_deg", "Flex. hanche D", "°"], ["left_leg_lift_deg", "Flex. hanche G", "°"],
];

export default function Assessments() {
  const pp = usePickedPatient();
  const { data: p } = usePatient(pp.pid);
  const { data: list } = useQuery({ queryKey: ["assessments", pp.pid], queryFn: () => api.get(`/patients/${pp.pid}/assessments`).then((r) => r.data), enabled: !!pp.pid, staleTime: 0 });
  return (
    <div data-testid="care-assessments">
      <PageHeader title="Évaluations" sub="Calibrations de la zone de mouvement (amplitudes articulaires simulées)"><SimBadge /><PatientPicker {...pp} /></PageHeader>
      {p && (
        <Panel title="Référence clinique (saisie thérapeute)" className="mb-6">
          <div className="flex flex-wrap gap-6 text-sm">
            <p>Flexion d'épaule max : <b>{p.clinical_profile.shoulder_flexion_max_deg}°</b></p>
            <p>Abduction max : <b>{p.clinical_profile.shoulder_abduction_max_deg}°</b></p>
            <p>Atteinte fonctionnelle : <b>{p.clinical_profile.functional_reach_cm} cm</b></p>
            <p>Côté atteint : <b>{p.clinical_profile.affected_side === "right" ? "Droit" : p.clinical_profile.affected_side === "left" ? "Gauche" : "Bilatéral"}</b></p>
          </div>
        </Panel>
      )}
      <Panel title="Historique des calibrations" testId="assessments-table">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[760px] text-sm">
            <thead><tr className="text-left text-xs uppercase text-muted-foreground/80"><th className="pb-2">Date</th>{COLS.map(([, l]) => <th key={l}>{l}</th>)}<th>Source</th></tr></thead>
            <tbody>
              {list?.map((a) => (
                <tr key={a.id} className="border-t border-border/60">
                  <td className="py-2.5">{fmtDateTime(a.created_at)}</td>
                  {COLS.map(([k, , u]) => <td key={k} className="font-mono">{a.values[k] ?? "—"}{a.values[k] !== undefined ? u : ""}</td>)}
                  <td className="text-xs text-muted-foreground">{a.input_source}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {!list?.length && <p className="text-sm text-muted-foreground">Aucune calibration.</p>}
      </Panel>
    </div>
  );
}
